<div class="shell" [class.sidebar-collapsed]="sidebarCollapsed" *ngIf="!loading && !profileLoadError; else stateTpl">
  <ng-container *ngIf="!accessDenied; else deniedTpl">
    <aside [class.collapsed]="sidebarCollapsed" [class.mobile-open]="mobileNavOpen">
      <div class="sidebar-head">
        <button type="button" class="ghost compact mobile-close" (click)="closeMobileMenu()">Fermer</button>
        <button type="button" class="ghost compact desktop-toggle" (click)="toggleSidebar()">
          {{ sidebarCollapsed ? 'Agrandir' : 'Réduire' }}
        </button>
      </div>

      <nav>
        <div class="brand">
          <h2>{{ sidebarCollapsed ? 'AF' : 'AfriFood Admin' }}</h2>
          <p class="identity" *ngIf="!sidebarCollapsed">{{ userDisplayName() }}</p>
          <p *ngIf="!sidebarCollapsed">{{ user?.email }} • {{ user?.role }}</p>
        </div>

        <a routerLink="/dashboard/stats" routerLinkActive="active" (click)="closeMobileMenu()">Statistiques</a>
        <a routerLink="/dashboard/moderation" routerLinkActive="active" (click)="closeMobileMenu()">Modération</a>
        <a routerLink="/dashboard/recipes" routerLinkActive="active" (click)="closeMobileMenu()">Recettes</a>
        <a routerLink="/dashboard/categories" routerLinkActive="active" (click)="closeMobileMenu()">Catégories</a>
        <a routerLink="/dashboard/users" routerLinkActive="active" (click)="closeMobileMenu()">Utilisateurs</a>
        <a *ngIf="canAccessReports" routerLink="/dashboard/reports" routerLinkActive="active" (click)="closeMobileMenu()">
          Signalements
        </a>
        <a routerLink="/dashboard/profile" routerLinkActive="active" (click)="closeMobileMenu()">Mon profil</a>
        <a routerLink="/dashboard/settings" routerLinkActive="active" (click)="closeMobileMenu()">Settings</a>
      </nav>

      <button type="button" class="logout" (click)="logout()">Déconnexion</button>
    </aside>

    <div class="overlay" *ngIf="mobileNavOpen" (click)="closeMobileMenu()"></div>

    <main>
      <header class="toolbar">
        <button type="button" class="ghost mobile-toggle" (click)="toggleMobileMenu()">Menu</button>
        <button type="button" class="ghost desktop-toggle-inline" (click)="toggleSidebar()">
          {{ sidebarCollapsed ? 'Agrandir la barre latérale' : 'Réduire la barre latérale' }}
        </button>

        <div class="notifications">
          <button type="button" class="ghost" (click)="toggleNotifications()">
            Notifications
            <span class="badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
          </button>

          <section class="notifications-panel" *ngIf="notificationsOpen">
            <header>
              <h3>Notifications</h3>
              <button type="button" class="ghost compact" (click)="markAllNotificationsRead()" [disabled]="unreadCount === 0">
                Tout marquer lu
              </button>
            </header>

            <p class="empty" *ngIf="notifications.length === 0">Aucune notification.</p>

            <ul *ngIf="notifications.length > 0">
              <li
                *ngFor="let notification of notifications; trackBy: notificationTrackBy"
                [class.unread]="!notification.isRead"
              >
                <button type="button" (click)="openNotification(notification)">
                  <span class="notification-line">
                    <span
                      class="kind-icon"
                      [class.recipe]="notification.kind === 'recipe_review'"
                      [class.inspiration]="notification.kind === 'inspiration_review'"
                      [class.comment]="notification.kind === 'comment_review'"
                      [class.report]="notification.kind === 'report_open'"
                      [attr.aria-label]="notificationKindLabel(notification.kind)"
                      [title]="notificationKindLabel(notification.kind)"
                    >
                      {{ notificationKindIcon(notification.kind) }}
                    </span>

                    <span class="notification-text">
                      <span class="title">{{ notification.title }}</span>
                      <span class="desc">{{ notification.description }}</span>
                      <span class="time">{{ notificationKindLabel(notification.kind) }} • {{ notificationTime(notification) }}</span>
                    </span>
                  </span>
                </button>
              </li>
            </ul>
          </section>
        </div>
      </header>

      <section class="content">
        <router-outlet></router-outlet>
      </section>
    </main>
  </ng-container>
</div>

<ng-template #stateTpl>
  <div class="state loading-state" *ngIf="loading">
    <span class="spinner" aria-hidden="true"></span>
    <span>Chargement du profil…</span>
  </div>

  <div class="state error-state" *ngIf="!loading && profileLoadError">
    <p>{{ profileLoadError }}</p>
    <button type="button" class="ghost retry" (click)="retryProfileLoad()">Réessayer</button>
  </div>
</ng-template>

<ng-template #deniedTpl>
  <div class="state">Accès refusé. Profil non autorisé.</div>
</ng-template>
